import { EChartsOption } from "echarts";

import { ITooltipBuilder } from "./chart-tooltip-builder";
import { IYAxisConfigBuilder } from "./chart-config-y-axis-builder";
import { formatDate } from "@src/app/utils/date";
import { ChartDefaultMapDataFormmater } from "./chart-map-data";
import { IAxisConfig, IChartBuildConfig, IGetChartData } from "@src/app/interfaces/chart-params.interface";

export class ChartConfigBuilder {

    private TooltipBuilder: ITooltipBuilder;
    private YAxisConfigBuilder: IYAxisConfigBuilder;

    private GridStyleConfigLeft = new Map<number, string>([[1, '4.5%'], [2, '4.5%'], [3, '8.5%'], [4, '8.5%']]);
    private GridStyleConfigRight = new Map<number, string>([[2, '5%'], [3, '5%'], [4, '9.5%']]);

    constructor(TooltipBuilder: ITooltipBuilder, YAxisConfigBuilder: IYAxisConfigBuilder) {
        this.TooltipBuilder = TooltipBuilder;
        this.YAxisConfigBuilder = YAxisConfigBuilder;
    }

    public BuildConfig(data: IChartBuildConfig, chartData: IGetChartData[]): EChartsOption {
        const { customParams } = data;
        const axisConfigsLength = this.getLengthAxisConfigs(customParams.axisConfigs || []);
        const theBiggestNumberInChart = data?.customParams?.theBiggestNumberInChart || 10;

        return {
            dataZoom: {
                left: 15,
                right: 20,
                show: customParams.isDataZoom,
                labelFormatter(_: any, valueStr: string) {
                  return formatDate('HH:mm', new Date(valueStr));
                },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'cross', label: { show: false } },
                formatter: (params: Object) => this.TooltipBuilder.formatTooltip(params, customParams.tooltipData),
            },
            grid: {
                left: this.GridStyleConfigLeft.get(axisConfigsLength) || '1.5%',
                right: this.GridStyleConfigRight.get(axisConfigsLength) || '1.5%',
                bottom: '12%',
                top: '9.5%',
            },
            legend: {
                data: customParams.legend,
                left: 10,
                itemGap: 20,
            },
            xAxis: {
                type: 'category',
                data: chartData.map(item => item.Time),
                axisTick: { alignWithLabel: true },
                axisLabel: {
                    rotate: 0,
                    fontSize: 12,
                    formatter: (value: string, index: number) => formatDate('HH:mm:ss', new Date(value)),
                },
            },
            yAxis: this.YAxisConfigBuilder.buildYAxisConfig(data.customParams.axisConfigs as IAxisConfig[], theBiggestNumberInChart),
            series: customParams.series.map((el: Object) => ({ 
                ...el,
                ...(new ChartDefaultMapDataFormmater(el, theBiggestNumberInChart).formatData()),
            })),
            ...data,
            customParams: undefined,
        };
    }

    private getLengthAxisConfigs(data: IAxisConfig[]): number {
        return data.filter(item => item.y.show !== false).length;
    }

}
